import dynamic from 'next/dynamic'
import Meta from 'components/meta/meta'
import Heading from 'components/heading/heading'
import { getData } from 'utils/api'
import Script from 'next/script'
import Selections from 'components/selections/women'
import styles from 'styles/page/moters-diena.module.scss'
import { cn } from 'utils/helpers'
import Image from 'components/image/image'
import Svg from 'components/svg/svg'
import Tulips from 'components/tulips/tulips'

const Women = dynamic(() => import('components/hits/women'))
const Builder = dynamic(() => import('components/builder/builder'))

export default function Page(props) {
    return (
        <>
            <Meta
                title="Moters dienos dovanos"
                image="/img/moters-diena.jpg"
                description="Pradžiugink ją nepaprastomis dovanomis"
            />
            <Script src="/tulips.js" strategy="lazyOnload" />
            <Script
                src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.1/TweenMax.min.js"
                strategy="lazyOnload"
                onLoad={() => {
                    if (typeof startTulips !== 'undefined' && typeof window.tulipsStarted === 'undefined') {
                        setTimeout(() => {
                            startTulips()
                        })
                    }
                }}
            />
            <Tulips />
            <div className={styles.hearts} />
            <div className={cn(styles.hero, 'mb72')}>
                <Svg name="paper-top" className={styles.paper} />
                <div className={styles.heroWrap}>
                    <Heading tag="h1" size="48">
                        Moters diena
                    </Heading>
                    <p>
                        Pradžiugink ją nepaprastomis <br />
                        dovanomis
                    </p>
                </div>
                <div className={styles.heroImg}>
                    <Image alt="Valentino diena" src="/img/moters-diena.jpg" width="900" height="600" />
                </div>
            </div>
            <Selections />
            <Builder data={props} />
            <Women />
        </>
    )
}
// <Faqs items={faqs} />
// <Themes />
// <Audiences />
// <Plan />
// <HomeArticles />
// <Categories />

export async function getServerSideProps(context) {
    return await getData('women-products', true, context)
}
